import type { MultiSelectDesignTokens, MultiSelectTokenSections } from '@openng/optimus-ui-themes/types/multiselect';

export const root: MultiSelectTokenSections.Root = {
	placeholderColor: '{surface.200}',
	lg: {
		paddingY: '0.5rem',
	},
};

export const colorScheme: MultiSelectTokenSections.ColorScheme = {
	light: {
		root: {
			placeholderColor: '{surface.200}',
		},
	},
};

export default {
	root,
	colorScheme,
} satisfies MultiSelectDesignTokens;
